import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import { useRouter } from "vue-router";
import { toAdmin } from "@/hooks/toAdmin";
import { useStore } from "vuex";
export default defineComponent({
  name: "Notice",
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs
  },
  setup: function setup() {
    var store = useStore();
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 表格加载


    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading; // 第一个table的初始化

    var tableData = ref([{}]);
    var totalNum = ref(0);
    var pageIndex = ref(1); // 获取待办分页

    function getTableOne() {
      return _getTableOne.apply(this, arguments);
    }

    function _getTableOne() {
      _getTableOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMessageUserPage"]({
                  pageIndex: pageIndex.value,
                  pageSize: 10
                });

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                tableData.value = _toConsumableArray(data);
                totalNum.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTableOne.apply(this, arguments);
    }

    getTableOne();

    function changPage(val) {
      pageIndex.value = val;
      getTableOne();
    } //缓存路由


    var keepRoute = store.state.keppPersonLive.keepViews; // 查看详情

    function getDetail(_x) {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(item) {
        var spArr, newTxt, keepName, setArray, _yield$globalProperti2, data, code;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                spArr = item.pcUrl.split('/');
                newTxt = spArr[spArr.length - 1];
                keepName = newTxt.replace(/^\S/, function (s) {
                  return s['toUpperCase']();
                });
                setArray = new Set(keepRoute);
                setArray.add(keepName);
                keepRoute = _toConsumableArray(setArray); // //清空其他keepname

                keepRoute = keepRoute.filter(function (val) {
                  return val == keepName || val == "Personal";
                });
                store.dispatch('keppPersonLive/setKeepView', keepRoute);
                _context5.next = 10;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMessageUserState"](item.messageId);

              case 10:
                _yield$globalProperti2 = _context5.sent;
                data = _yield$globalProperti2.data;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  if (item.configKey == 'meeting_apply' || item.configKey == "meeting_leave_apply") {
                    ElMessageBox({
                      title: "提示",
                      message: "\u5373\u5C06\u8DF3\u8F6C\u540E\u53F0\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F",
                      showCancelButton: true,
                      confirmButtonText: "确定",
                      cancelButtonText: "取消"
                    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (item.sendStatus != 1) {
                                store.dispatch("webSocket/setactionbeage", store.state.webSocket.listlength - 1);
                              }

                              toAdmin("meeting/record");

                            case 2:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }))).catch(function () {// console.log("2222");
                    });
                  } else if (item.configKey == "activity_apply" || item.configKey == "activity_leave_apply") {
                    ElMessageBox({
                      title: "提示",
                      message: "\u5373\u5C06\u8DF3\u8F6C\u540E\u53F0\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F",
                      showCancelButton: true,
                      confirmButtonText: "确定",
                      cancelButtonText: "取消"
                    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              if (item.sendStatus != 1) {
                                store.dispatch("webSocket/setactionbeage", store.state.webSocket.listlength - 1);
                              }

                              toAdmin("activity/record");

                            case 2:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }))).catch(function () {// console.log("2222");
                    });
                  } else if (item.configKey == "train_apply" || item.configKey == "train_leave_apply") {
                    ElMessageBox({
                      title: "提示",
                      message: "\u5373\u5C06\u8DF3\u8F6C\u540E\u53F0\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F",
                      showCancelButton: true,
                      confirmButtonText: "确定",
                      cancelButtonText: "取消"
                    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                      return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              if (item.sendStatus != 1) {
                                store.dispatch("webSocket/setactionbeage", store.state.webSocket.listlength - 1);
                              }

                              toAdmin("train/record");

                            case 2:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }))).catch(function () {// console.log("2222");
                    });
                  } else if (item.configKey.indexOf("publish_repeal") != -1) {
                    ElMessageBox({
                      title: "提示",
                      message: item.content,
                      confirmButtonText: "确定"
                    });

                    if (item.sendStatus != 1) {
                      store.dispatch("webSocket/setactionbeage", store.state.webSocket.listlength - 1);
                    }
                  } else if (item.configKey.indexOf("publish") != -1) {
                    if (item.sendStatus != 1) {
                      store.dispatch("webSocket/setactionbeage", store.state.webSocket.listlength - 1);
                    }

                    router.push({
                      path: item.pcUrl
                    });
                  } else {
                    ElMessageBox({
                      title: "提示",
                      message: item.content,
                      confirmButtonText: "确定"
                    });

                    if (item.sendStatus != 1) {
                      store.dispatch("webSocket/setactionbeage", store.state.webSocket.listlength - 1);
                    }
                  }
                } else {
                  ElMessage.error(data.msg);
                }

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _getDetail.apply(this, arguments);
    }

    return {
      tableloading: tableloading,
      loading: loading,
      tableData: tableData,
      totalNum: totalNum,
      pageIndex: pageIndex,
      changPage: changPage,
      getDetail: getDetail
    };
  }
});